<template>
    <div>
        <!-- Desktop -->
        <div class="hidden md:block">
            <div class="flex items-center ml-4 md:ml-6">
                <div class="relative ml-3">
                    <div>
                        <button 
                            class="flex items-center max-w-xs text-sm text-white rounded-full focus:outline-none focus:shadow-solid"
                            @click="toggleVisibility"
                            @keydown.space.exact.prevent="toggleVisibility"
                            @keydown.esc.exact="hideDropdown"
                            @keydown.shift.tab="hideDropdown"
                            @keydown.up.exact.prevent="startArrowKeys"
                            @keydown.down.exact.prevent="startArrowKeys"
                        >
                            <img :class="{'border-2 border-white': isVisible }" class="w-8 h-8 rounded-full" src="@/assets/avatar.jpg" alt="" />
                        </button>
                    </div>
                    <div v-on-clickaway="hideDropdown" v-if="isVisible" ref="dropdown" x-transition:enter="transition ease-out duration-100" x-transition:enter-start="transform opacity-0 scale-95" x-transition:enter-end="transform opacity-100 scale-100" x-transition:leave="transition ease-in duration-75" x-transition:leave-start="transform opacity-100 scale-100" x-transition:leave-end="transform opacity-0 scale-95" class="absolute right-0 w-48 mt-2 origin-top-right rounded-md shadow-lg">
                        <div class="py-1 bg-white rounded-md shadow-xs">
                            <router-link :to="{ name: 'Home' }" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">{{ $t('user.home') }}</router-link>
                            <router-link :to="{ name: 'Dashboard' }" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">{{ $t('user.dashboard') }}</router-link>
                            <span @click="signOut" class="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100">{{ $t('user.signout') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mobile Menu Button-->
        <div class="flex -mr-2 md:hidden">
            <button 
                class="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
                @click="toggleVisibility"
                @keydown.space.exact.prevent="toggleVisibility"
                @keydown.esc.exact="hideDropdown"
                @keydown.shift.tab="hideDropdown"
                @keydown.up.exact.prevent="startArrowKeys"
                @keydown.down.exact.prevent="startArrowKeys"
                >
                <svg class="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                    <path :class="{'hidden': isVisible, 'inline-flex': !isVisible }" class="inline-flex" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                    <path :class="{'hidden': !isVisible, 'inline-flex': isVisible }" class="" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <!-- Mobile Menu Content -->
        <div :class="{'block': isVisible, 'hidden': !isVisible}" class="md:hidden">
            <ul class="px-2 pt-2 pb-3 sm:px-3">
                <li href="#" class="block px-3 py-2 text-base font-medium text-white bg-gray-900 rounded-md focus:outline-none focus:text-white focus:bg-gray-700">Dashboard</li>
                <li href="#" class="block px-3 py-2 mt-1 text-base font-medium text-gray-300 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700">Event</li>
            </ul>
            <div class="pt-4 pb-3 border-t border-gray-700">
                <div class="flex items-center px-5">
                    <div class="flex-shrink-0">
                        <img class="w-10 h-10 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" />
                    </div>
                    <div class="ml-3">
                        <div class="text-base font-medium leading-none text-white">Tom Cook</div>
                        <div class="mt-1 text-sm font-medium leading-none text-gray-400">tom@example.com</div>
                    </div>
                </div>
                <div class="px-2 mt-3">
                    <router-link :to="{ name: 'Home' }" class="block px-3 py-2 text-base font-medium text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700">{{ $t('user.profile') }}</router-link>
                    <router-link :to="{ name: 'Home' }" class="block px-3 py-2 mt-1 text-base font-medium text-gray-400 rounded-md hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700">{{ $t('user.settings') }}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mixin as clickaway } from "vue-clickaway";
    import * as firebase from "firebase/app";
    import "firebase/auth";

    // Components
    

    export default {
        components: {
            
        },
        mixins: [ clickaway ],
        data() {
            return {
            isVisible: false,
            focusedIndex: 0,
            }
        },
        methods: {
            toggleVisibility() {
            this.isVisible = !this.isVisible
            },
            hideDropdown() {
            this.isVisible = false
            this.focusedIndex = 0
            },
            startArrowKeys() {
            if (this.isVisible) {
                // this.$refs.account.focus()
                this.$refs.dropdown.children[0].children[0].focus()
            }
            },
            focusPrevious(isArrowKey) {
            this.focusedIndex = this.focusedIndex - 1
            if (isArrowKey) {
                this.focusItem()
            }
            },
            focusNext(isArrowKey) {
            this.focusedIndex = this.focusedIndex + 1
            if (isArrowKey) {
                this.focusItem()
            }
            },
            focusItem() {
            this.$refs.dropdown.children[this.focusedIndex].children[0].focus()
            },
            async signOut(){
                try {
                    await firebase.auth().signOut();
                    this.isVisible = false
                    this.focusedIndex = 0
                    this.$router.replace({ name: 'Home' });
                } catch (error) {
                    console.log(error);
                }
            }

        }
    }
</script>

<style lang="scss" scoped>

</style>